(function () {
  if (window.freejoyLikeBadgeLoaded) return;
  window.freejoyLikeBadgeLoaded = true;

  const storageKey = (productId) => `freejoy_product_like_${productId}`;
  const readLiked = (productId) => {
    try {
      return localStorage.getItem(storageKey(productId)) === 'true';
    } catch (error) {
      return false;
    }
  };
  const saveLiked = (productId, liked) => {
    try {
      localStorage.setItem(storageKey(productId), String(liked));
    } catch (error) {
      // The visual state still works when storage is unavailable.
    }
  };
  const format = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en').format(value);

  function applyState(productId, liked) {
    document.querySelectorAll(`[data-product-like-badge][data-product-id="${productId}"]`).forEach((badge) => {
      const initialLikes = Number.parseInt(badge.dataset.initialLikes || '0', 10) || 0;
      const button = badge.querySelector('[data-like-button]');
      const count = badge.querySelector('[data-like-count]');
      if (count) count.textContent = format(initialLikes + (liked ? 1 : 0));
      if (button) {
        button.setAttribute('aria-pressed', String(liked));
        button.setAttribute('aria-label', `${format(initialLikes + (liked ? 1 : 0))} likes, ${liked ? badge.dataset.likedLabel : badge.dataset.unlikedLabel}`);
      }
    });
  }

  function initializeBadge(badge) {
    if (badge.dataset.likeReady === 'true') return;
    badge.dataset.likeReady = 'true';
    const productId = badge.dataset.productId;
    applyState(productId, readLiked(productId));
    badge.querySelector('[data-like-button]')?.addEventListener('click', () => {
      const liked = !readLiked(productId);
      saveLiked(productId, liked);
      applyState(productId, liked);
    });
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-product-like-badge]').forEach(initializeBadge);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
